import WithSideBarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import './scheduleTemplate.scss';
import TemplateCard from './scheduleTemplateCard/scheduleTemplateCard';
import { Link } from 'react-router-dom';
import HolidaySelectionModal from './holidaySelectionModal/holidaySelectionModal';
const ScheduleTemplate = () => {
    return (
        <WithSideBarAndNavBar>
            <div className="scheduleTemplate">
                <div className="scheduleTemplateTitleBar">
                    <div className="header">일정템플릿 관리</div>
                    <Link to="/add-schedule-template" className="button">
                        +추가하기
                    </Link>
                </div>

                <div className="container">
                    <TemplateCard
                        name={'템플릿명'}
                        type={'고정근무'}
                        hours={'월, 화,수, 목, 금 | 9:00 ~ 18:00 (휴식 60분 포함)'}
                    />
                    <TemplateCard
                        name={'템플릿명'}
                        type={'선택적근무'}
                        hours={' 1, 2, 3, 4 주 | 월, 화,수, 목, 금 | 9:00 ~ 18:00 (휴식 60분 포함)'}
                    />
                    <TemplateCard name={'템플릿명'} type={'자율출퇴근'} hours={'자율출퇴근은 출퇴근이 자유롭습니다'} />

                    <div className="emptyTemplateCard"> </div>
                    {/* <HolidaySelectionModal
                        header="추가완료"
                        description={'근로템플릿이 추가되었습니다.'}
                        buttonText={'확인'}
                        title={'addition'}
                    />
                    <HolidaySelectionModal
                        header="수정완료"
                        description={'근로템플릿이 수정되었습니다.'}
                        buttonText={'확인'}
                        title={'modification'}
                    /> */}
                </div>
            </div>
        </WithSideBarAndNavBar>
    );
};

export default ScheduleTemplate;
